import { render, staticRenderFns } from "./IconSvgSort.vue?vue&type=template&id=8e5166ee&scoped=true&"
import script from "./IconSvgSort.vue?vue&type=script&lang=js&"
export * from "./IconSvgSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5166ee",
  null
  
)

export default component.exports